'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.NO = exports.FOP = exports.PO = exports.FO = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Typ subjektu.
 */

/**
 * Fyzická osoba.
 */
var FO = exports.FO = 'FO';

/**
 * Právnická osoba.
 */
var PO = exports.PO = 'PO';

/**
 * Podnikající fyzická osoba.
 */
var FOP = exports.FOP = 'FOP';

/**
 * Neznámá osoba.
 */
var NO = exports.NO = 'NO';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [FO, PO, FOP, NO];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, FO, { caption: 'Fyzická osoba.' }), (0, _defineProperty3.default)(_params, PO, { caption: 'Právnická osoba.' }), (0, _defineProperty3.default)(_params, FOP, { caption: 'Podnikající fyzická osoba.' }), (0, _defineProperty3.default)(_params, NO, { caption: 'Neznámá osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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